import { localStrageSettings } from './config.js';

export default {
  init() {
    let request = window.indexedDB.open(localStrageSettings.dbname, localStrageSettings.version);
    request.onupgradeneeded = (event) => {
      let db = event.target.result;
      db.createObjectStore('settings', {keyPath: 'name'});
    };
  },
  get(key) {
    return new Promise((res, rej) => {
      let request = window.indexedDB.open(localStrageSettings.dbname, localStrageSettings.version);
      request.onsuccess = (event) => {
      let db = event.target.result;
      let transaction = db.transaction('settings', 'readwrite');
      let settingsStore = transaction.objectStore('settings');
      let keyObject = settingsStore.get(key);
        keyObject.onsuccess = (event) => {
          let r = event.target.result;
          if(r) {
            res(r.value);
          } else {
            res(null);
          }
        };
        keyObject.onerror = e => {
          rej(e);
        }
      }
    });
  },
  put(key, value) {
    return new Promise((res, rej) => {
      let request = window.indexedDB.open(localStrageSettings.dbname, localStrageSettings.version);
      request.onsuccess = (event) => {
        let db = event.target.result;
        let transaction = db.transaction('settings', 'readwrite');
        let settingsStore = transaction.objectStore('settings');
        let storeObject = settingsStore.put({name: key, value: value});
          storeObject.onsuccess = (event) => {
            let r = event.target.result;
            if(event.target.result) {
              res(r);
            } else {
              rej(new Error('result not found.'));
            }
          };
          storeObject.onerror = e => rej(e);
      };
    });
  }
}
